

// REMOVE UM PRODUTO DO CARRINHO PELO ÍNDICE, SEM MUTAR OS DADOS ORIGINAIS
export function deleteProduct({ index, cart }) {
    const products = cart.products.filter((_, i) => i !== index);

    return {
        ...cart,
        products,
        cart_price: products.reduce((total, product) => total + product.total_price, 0),
    };
}
